import ClaudeIcon from '@/assets/icons/claude.svg?react';
import OpenAiIcon from '@/assets/icons/openai.svg?react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';
import type { Agent } from '../model/first-run';

type AgentChoiceProps = { agent: Agent; onPick: (agent: Agent) => void; onContinue: () => void };

const CHOICES = [
  {
    agent: 'claude-code',
    name: 'Claude Code',
    Icon: ClaudeIcon,
    text: 'Self-hosted environment. Needs a Claude Team or Enterprise organization.',
  },
  {
    agent: 'codex',
    name: 'Codex',
    Icon: OpenAiIcon,
    text: 'OpenAI Agents API. Point a webhook at Macswarm.',
  },
] as const;

export function AgentChoice({ agent, onPick, onContinue }: AgentChoiceProps) {
  return (
    <>
      <fieldset className="grid grid-cols-[repeat(auto-fit,minmax(min(220px,100%),1fr))] gap-2.5">
        <legend className="sr-only">Agent</legend>
        {CHOICES.map((choice) => {
          const isChecked = choice.agent === agent;
          return (
            <label
              key={choice.agent}
              className={cn(
                'flex cursor-pointer flex-col items-start gap-2 rounded-tile border-2 bg-surface-2 p-4 text-left transition-tone has-focus-visible:outline-2 has-focus-visible:outline-accent has-focus-visible:outline-offset-2',
                isChecked ? 'border-accent-mark' : 'border-transparent hover:bg-surface-3',
              )}
            >
              <input
                type="radio"
                name="agent"
                value={choice.agent}
                checked={isChecked}
                onChange={() => onPick(choice.agent)}
                className="sr-only"
              />
              <span className="flex items-center gap-2.5 font-semibold">
                <choice.Icon aria-hidden="true" className="size-5 shrink-0" />
                {choice.name}
              </span>
              <span className="text-muted">{choice.text}</span>
            </label>
          );
        })}
      </fieldset>
      <Button variant="primary" size="lg" className="self-start" onClick={onContinue}>
        Continue
      </Button>
    </>
  );
}
